import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "container",
  "use": "container-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"container\"><path d=\"M15.613 5H6.387A2.386 2.386 0 0 0 4 7.387v7.227A2.386 2.386 0 0 0 6.387 17h9.227a2.387 2.387 0 0 0 2.387-2.387V7.387A2.39 2.39 0 0 0 15.613 5m.887 9.613a.89.89 0 0 1-.887.887H6.387a.89.89 0 0 1-.887-.887V7.387c0-.489.398-.887.887-.887h9.227c.489 0 .887.398.887.887v7.226zM10.249 14h1.5V8.002h-1.5zm-3 0h1.5V8.002h-1.5zm6 0h1.5V8.002h-1.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol